/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect } from "react";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  useQuery,
  ApolloLink,
  gql,
} from "@apollo/client";
import { RestLink } from "apollo-link-rest";
import { HttpLink } from "apollo-link-http";
import Search_Results from "./Search_Results";
import { useSelector } from "react-redux";
import { setContext } from "@apollo/client/link/context";

const SearchCandidateMarket = (props) => {
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;

  const authTokenValue = useSelector((state) => state.authReducer.user.authToken);
  const userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const ImpersonationId = useSelector((state) => state.authReducer.impersonationId);

  // const GetGigs = props.user.Gigs;
  const [search, setSearch] = useState("");
  const [gigset, setGigSet] = useState();
  const restLink = new RestLink({
    endpoints: {
      openExchangeRate: "https://open.exchangerate-api.com/v6/",
    },
  });

  const httpLink = new HttpLink({
    uri: `${BackendApiBaseUrl}/guest/skilllisting/search`,
  });

  const authLink = setContext((_, { headers }) => {
    if(ImpersonationId){
      return {
        headers: {
          ...headers,
          authorization: authTokenValue ? `${authTokenValue}` : "",
          email: userProfile?.EmailAddress,
          impersonationid:ImpersonationId, 
        },
      };
    }
    else{
      return {
      headers: {
        ...headers,
        authorization: authTokenValue ? `${authTokenValue}` : "",
        email: userProfile?.EmailAddress, 
      },
    }}
  });

  const client = new ApolloClient({
    // uri: `${BackendApiBaseUrl}/query`,
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
  });

  const Query = () => {
  };
  return (
    <ApolloProvider client={client}>
      <Search_Results job_title={props.job_title} job_id={props.job_id} />
    </ApolloProvider>
  );
};

export default SearchCandidateMarket;
